import { render, staticRenderFns } from "./QuestionWritingSort.vue?vue&type=template&id=43faca88"
import script from "./QuestionWritingSort.vue?vue&type=script&lang=js"
export * from "./QuestionWritingSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports